<script setup>
const props = defineProps({
  tabs: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'default', // default, primary
  },
  tabClass: String,
})

defineEmits(['update:modelValue'])
const tabClassAvtive = computed(() => {
  return {
    default: 'bg-pageTertiary !text-textPrimary',
    primary: 'bg-fillPagePrimary !text-textPrimary',
  }[props.type]
})
</script>

<template>
  <div class="flex items-center" :class="{ 'bg-pageTertiary rounded-full p-0.5': type === 'primary' }">
    <div
      v-for="i in tabs"
      :key="i.key"
      class="flex items-center h-full px-2 rounded-full cursor-pointer text-textTertiary"
      :class="[{ [tabClassAvtive]: modelValue === i.key }, tabClass]"
      @click="$emit('update:modelValue', i.key)"
    >
      {{ i.label }}
    </div>
  </div>
</template>
